import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { DataService } from "../../../data.service";
import { TrackDataModel, ClientNameModel, AppServerErrorModel } from '../../../model';
import { TrackUtils } from '../../../shared/track-utils';
import { ConfirmationService } from 'primeng/api';
import { alertMessage, confirmMessage } from '../../../shared/message-utils';
import { AppServerError } from '../../../common/errors';

@Component({
    selector: 'app-delivery',
    templateUrl: './track-delivery.component.html',
    styleUrls: ['./track-delivery.component.css'],
    standalone: false
})
export class TrackDeliveryComponent implements OnInit {
    @ViewChild("soundBeep") soundBeepEl!: ElementRef;
    @ViewChild('tracknumInput') tracknumInput!: ElementRef<HTMLInputElement>;

    tracknum!: string;
    trackComment!: string;

    selectedClient!: ClientNameModel;
    clientNamesList!: ClientNameModel[];
    filteredClients: ClientNameModel[] = [];
    clientTracks!: TrackDataModel[];

    constructor(private dataService: DataService, private confirmationService: ConfirmationService) {
    }

    ngOnInit() {
        this.dataService.clientNamesList().subscribe((data: ClientNameModel[]) => {
            this.clientNamesList = data;
        });

    }

    loadClientTracks() {
        if (this.selectedClient && this.selectedClient.id) {
            const subscr = this.dataService.clientTracks(this.selectedClient.id).subscribe({
                next: (result) => {
                    this.clientTracks = result;
                },
                error: (err) => {
                    subscr.unsubscribe();
                    alertMessage(this.confirmationService, err.message);
                },
                complete: () => {
                    subscr.unsubscribe();
                }
            });
        }
    }

    clientSelected() {
        this.loadClientTracks();
    }

    onKeyUp(event: KeyboardEvent) {
        if (event.code.endsWith('Enter')) {
            this.deliverPackage();
        }
    }

    filterItems(event: any) {
        //in a real application, make a request to a remote url with the query and return filtered results, for demo we filter at client side
        this.filteredClients = [];
        let filtered: any[] = [];
        let query = event.query;

        for (let i = 0; i < this.clientNamesList.length; i++) {
            let item = this.clientNamesList[i];
            if (item.client_code && item.client_code.toLowerCase().indexOf(query.toLowerCase()) >= 0) {
                filtered.push(item);
            }
        }

        this.filteredClients = filtered;
    }

    deliverPackage() {
        if (!this.selectedClient || !this.selectedClient.id || !this.tracknum.trim()) {
            return;
        }

        const track = TrackUtils.checkTrack(this.tracknum);

        if (!track) {
            const confimation = prompt(TrackUtils.alertMessage, this.tracknum);
            if (confimation != null) {
                this.tracknum = confimation;
            } else {
                return;
            }
        } else {
            this.tracknum = track;
        }

        const subscr1 = this.dataService.makePackageDelivered(this.selectedClient.id, this.tracknum, this.trackComment, false).subscribe({
            next: (result) => {
                // reload data
                this.loadClientTracks();
                // clean tracknum
                this.tracknum = '';
                this.trackComment = '';
            },
            error: (error) => {
                if (error && error instanceof AppServerError) {
                    const appError = error.errData

                    switch (appError.message) {
                        case 'no_package_found':
                            this.soundBeepEl.nativeElement.play();
                            confirmMessage(
                                this.confirmationService,
                                `Посылка "${appError.value.tracknum}" не найдена! Хотите создать и отдать?`,
                                // accept
                                () => {
                                    const subscr3 = this.dataService.trackReceived({
                                        tracknum: this.tracknum,
                                        create_track: true,
                                        client_id: this.selectedClient.id,
                                        package_weight: undefined,
                                        package_date: undefined,
                                    }).subscribe({
                                        next: (data) => {
                                            // теперь надо выдать посылку. перед выдачей необходимо выдержать небольшую паузу
                                            setTimeout(() => {
                                                this.dataService.makePackageDelivered(this.selectedClient.id, this.tracknum.trim(), this.trackComment, true).subscribe(
                                                    (result) => {
                                                        alertMessage(this.confirmationService, "Внимание! Клиент забрал посылку",
                                                            () => {
                                                                this.tracknumInput.nativeElement.focus();
                                                            }
                                                        );
                                                        // reload data
                                                        this.loadClientTracks();
                                                        // clean tracknum
                                                        this.tracknum = '';
                                                        this.trackComment = '';
                                                    }
                                                );
                                            }, 1000);

                                        },
                                        complete: () => {
                                            subscr3.unsubscribe();
                                        }
                                    });
                                },
                                // reject
                                () => {
                                    this.tracknumInput.nativeElement.focus();
                                }
                            );

                            break;

                        case 'not_belong_to_client':
                            this.soundBeepEl.nativeElement.play();

                            confirmMessage(
                                this.confirmationService,
                                `Посылка "${appError.value.tracknum}" не принадлежит клиенту! Хотите отдать?`,
                                // accept
                                () => {
                                    // Save it!
                                    this.dataService.makePackageDelivered(this.selectedClient.id, this.tracknum.trim(), this.trackComment, true).subscribe(
                                        (result) => {
                                            alertMessage(this.confirmationService, "Внимание! Клиент забрал посылку");
                                            // reload data
                                            this.loadClientTracks();
                                            // clean tracknum
                                            this.tracknum = '';
                                            this.trackComment = '';
                                        }
                                    );
                                },
                                // reject
                                () => {
                                    // clean tracknum
                                    this.tracknum = '';
                                    this.trackComment = '';
                                }
                            );

                            break;
                    }
                }
            },
            complete: () => {
                subscr1.unsubscribe();
            }
        })
    }

    pasteTracknum(tracknum: string) {
        this.tracknum = tracknum;
    }

}